import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconOilSaturationMapSizeS from './IconOilSaturationMap_size_s';

const props: CreateIconArguments = {
  l: IconOilSaturationMapSizeS,
  m: IconOilSaturationMapSizeS,
  s: IconOilSaturationMapSizeS,
  xs: IconOilSaturationMapSizeS,
  name: 'IconOilSaturationMap',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
